<template>
  <div>
    <div class="mx-auto mt-16 pt-1" :class="isMobile ? 'w-full px-2' : 'section'">
      <div class="bg-gray-400 mt-2" :class="isMobile ? 'text-sm p-1' : 'pb-1'">
        <div class="text-white text-center font-bold" :class="isMobile ? 'text-base' : 'text-lg'">=ご利用にあたって=</div>
        <div :class="isMobile ? 'text-sm px-2 py-1' : 'text-center pb-1'">
          新しい運賃は運賃改定日である2026年3月14日以降お買い求め分から適用いたします。<br />
          2026年3月13日までにお買い求めのきっぷは、有効開始日・乗車日が3月14日以降であっても改定前の運賃で発売いたします。<br />
          ※3月14日以降に乗車される場合でも、差額のお支払いは不要です。
        </div>
      </div>
      <div class="text-center mx-auto mt-2">
        <button class="w-40 font-bold text-xl rounded-md py-1" @click="change('fare')"
          :class="[mode === 'fare' ? 'text-white bg-blue-600 border-blue-600 border border-blue-600' : 'bg-gray-200 text-blue-600 border border-blue-600']">
          普通運賃・料金
        </button>
        <button class="w-40 font-bold text-xl rounded-md py-1 ml-2" @click="change('teiki')"
          :class="[mode === 'teiki' ? 'text-white bg-blue-600 border-blue-600 border border-blue-600' : 'bg-gray-200 text-blue-600 border border-blue-600']">
          定期運賃
        </button>
      </div>
      <div class="text-center mx-auto mt-2 mb-4">
        <div class="float-left text-white base-color rounded-md py-1" :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
          乗車駅
        </div>
        <div class="pl-2 pt-1" id="from" ref="from" :class="isMobile ? 'ml-20' : 'ml-24'">
        </div>
      </div>
      <div>
        <div class="text-center mx-auto mt-2 mb-4" v-show="viaCount >= 1">
          <div class="float-left text-white base-color rounded-md py-1" :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
            経由駅
          </div>
          <div class="float-right relative mr-6 cursor-pointer" @click="deleteVia(1)">
            <div class="absolute mt-2">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#000000">
                <path
                  d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
              </svg>
            </div>
          </div>
          <div class="pl-2 pt-1" id="via1" ref="via1" :class="isMobile ? 'ml-20' : 'ml-24'">
          </div>
        </div>
        <div class="text-center mx-auto mt-2 mb-4" v-show="viaCount >= 2">
          <div class="float-left text-white base-color rounded-md py-1" :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
            経由駅
          </div>
          <div class="float-right relative mr-6 cursor-pointer" @click="deleteVia(2)">
            <div class="absolute mt-2">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#000000">
                <path
                  d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
              </svg>
            </div>
          </div>
          <div class="pl-2 pt-1" id="via2" ref="via2" :class="isMobile ? 'ml-20' : 'ml-24'">
          </div>
        </div>
        <div class="text-center mx-auto mt-2 mb-6" v-show="viaCount >= 3">
          <div class="float-left text-white base-color rounded-md py-1" :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
            経由駅
          </div>
          <div class="float-right relative mr-6 cursor-pointer" @click="deleteVia(3)">
            <div class="absolute mt-2">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#000000">
                <path
                  d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
              </svg>
            </div>
          </div>
          <div class="pl-2 pt-1" id="via3" ref="via3" :class="isMobile ? 'ml-20' : 'ml-24'">
          </div>
        </div>
      </div>
      <div v-show="viaCount < 3" class="text-center">
        <span class="text-blue-600 font-bold mb-4 cursor-pointer" @click="addVia()">＋経由駅を追加</span>
      </div>
      <div class="text-center mx-auto mt-2">
        <div class="float-left text-white base-color rounded-md py-1" :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
          降車駅
        </div>
        <div class="pl-2 pt-1" id="to" ref="to" :class="isMobile ? 'ml-20' : 'ml-24'">
        </div>
      </div>
      <div class="my-2" v-if="mode === 'teiki'">
        <template v-if="isMobile">
          <div class="font-bold float-left ml-2 mt-2">定期種別：</div>
          <select v-model="teikiKind" class="border-2 rounded mt-2">
            <option value="bussiness">通勤/オフピーク</option>
            <option value="university">通学 (大学)</option>
            <option value="highSchool">通学 (高校)</option>
            <option value="juniorHighSchool">通学 (中学)</option>
          </select>
        </template>
        <template v-else>
          <div class="font-bold ml-2 pt-2">定期種別</div>
          <div class="float-left ml-4 pt-1">
            <input id="bussiness" type="radio" v-model="teikiKind" value="bussiness" /><label for="bussiness"
              class="ml-2">通勤/オフピーク</label>
          </div>
          <div class="float-left ml-6 pt-1">
            <input id="university" type="radio" v-model="teikiKind" value="university" /><label for="university"
              class="ml-2">通学 (大学)</label>
          </div>
          <div class="float-left ml-6 pt-1">
            <input id="highSchool" type="radio" v-model="teikiKind" value="highSchool" /><label for="highSchool"
              class="ml-2">通学 (高校)</label>
          </div>
          <div class="float-left ml-6 pt-1">
            <input id="juniorHighSchool" type="radio" v-model="teikiKind" value="juniorHighSchool" /><label
              for="juniorHighSchool" class="ml-2">通学 (中学)</label>
          </div>
        </template>
      </div>
      <div class="clear-both"></div>
      <div v-for="(error, index) in errors" :key="index" class="w-full text-center text-red-500 font-bold">
        {{ error }}
      </div>
      <div class="text-center mx-auto mt-4">
        <button class="font-bold text-xl w-64 rounded-md py-1 text-white bg-blue-600" :class="isMobile ? '' : ''"
          @click="search('before')">
          改定日前に購入
        </button>
        <button class="font-bold text-xl w-64 rounded-md py-1 text-white bg-red-600" :class="isMobile ? 'mt-2' : 'ml-2'"
          @click="search('after')">
          改定日以降に購入
        </button>
      </div>
      <div class="text-red-500 mt-8 ml-4">
        <ul v-if="mode === 'fare'">
          <li>※乗車駅にはJR各社の駅を入力してください。</li>
          <li>※降車駅にはJR以外の鉄道会社の駅も入力可能です。（発売範囲には制限があります。）</li>
          <li>※検索結果の運賃・料金及び区間等の制約事項は<button class="text-blue-600 underline break-all cursor-pointer"
              @click="openUpdate">注釈ページ</button>をご覧ください。</li>
        </ul>
        <ul v-else-if="mode === 'teiki'">
          <li>※乗車駅にはJR東日本の駅を入力してください。</li>
          <li>※降車駅にはJR以外の鉄道会社の駅も入力可能です。（発売範囲には制限があります。）</li>
          <li>※検索結果の運賃・料金及び区間等の制約事項は<button class="text-blue-600 underline break-all cursor-pointer"
              @click="openUpdate">注釈ページ</button>をご覧ください。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Constants from '@/constants';

export default {
  data() {
    return {
      mode: 'fare',
      from: null,
      to: null,
      via1: null,
      via2: null,
      via3: null,
      viaCount: 0,
      teikiKind: 'bussiness',
      errors: [],
    }
  },
  computed: mapGetters({
    isMobile: 'getIsMobile',
  }),
  async mounted() {
    this.$store.commit('reset');
    this.from = new window.expGuiStation(this.$refs.from);
    this.from.setConfigure("apiURL", Constants.API_BASE_URL);
    this.from.setConfigure("type", this.from.TYPE_TRAIN);
    this.from.setConfigure("corporationBind", "ＪＲ");
    this.from.setConfigure("agent", 1);
    this.from.setConfigure("isMobile", this.isMobile);
    this.from.dispStation();
    this.to = new window.expGuiStation(this.$refs.to);
    this.to.setConfigure("apiURL", Constants.API_BASE_URL);
    this.to.setConfigure("type", this.to.TYPE_TRAIN);
    this.to.setConfigure("agent", 1);
    this.to.setConfigure("isMobile", this.isMobile);
    this.to.dispStation();
    this.via1 = new window.expGuiStation(this.$refs.via1);
    this.via1.setConfigure("apiURL", Constants.API_BASE_URL);
    this.via1.setConfigure("type", this.via1.TYPE_TRAIN);
    this.via1.setConfigure("agent", 1);
    this.via1.setConfigure("isMobile", this.isMobile);
    this.via1.dispStation();
    this.via2 = new window.expGuiStation(this.$refs.via2);
    this.via2.setConfigure("apiURL", Constants.API_BASE_URL);
    this.via2.setConfigure("type", this.via2.TYPE_TRAIN);
    this.via2.setConfigure("agent", 1);
    this.via2.setConfigure("isMobile", this.isMobile);
    this.via2.dispStation();
    this.via3 = new window.expGuiStation(this.$refs.via3);
    this.via3.setConfigure("apiURL", Constants.API_BASE_URL);
    this.via3.setConfigure("type", this.via3.TYPE_TRAIN);
    this.via3.setConfigure("agent", 1);
    this.via3.setConfigure("isMobile", this.isMobile);
    this.via3.dispStation();
    this.from.bind("blur", () => {
      this.from.closeStationList();
    });
    this.to.bind("blur", () => {
      this.to.closeStationList();
    });
    this.via1.bind("blur", () => {
      this.via1.closeStationList();
    });
    this.via2.bind("blur", () => {
      this.via2.closeStationList();
    });
    this.via3.bind("blur", () => {
      this.via3.closeStationList();
    });
    if (this.$route.query.viaList) {
      let viaList = this.$route.query.viaList.split(':');
      const from = viaList.shift();
      this.from.setStation(from);
      const to = viaList.pop();
      this.to.setStation(to);
      if (viaList.length > 0) {
        this.via1.setStation(viaList[0]);
        this.viaCount = 1;
      }
      if (viaList.length > 1) {
        this.via2.setStation(viaList[1]);
        this.viaCount = 2;
      }
      if (viaList.length > 2) {
        this.via3.setStation(viaList[2]);
        this.viaCount = 3;
      }
      this.from.closeStationList();
      this.to.closeStationList();
      this.via1.closeStationList();
      this.via2.closeStationList();
      this.via3.closeStationList();
    }
    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode;
      if (this.mode === 'fare') {
        this.from.setConfigure("corporationBind", "ＪＲ");
      } else if (this.mode === 'teiki') {
        this.from.setConfigure("corporationBind", "ＪＲ東日本");
      }
    }
    if (this.$route.query.teikiKind) {
      this.teikiKind = this.$route.query.teikiKind;
    }
  },
  methods: {
    change: function (value) {
      this.errors.splice(0);
      if (this.mode !== value) {
        this.mode = value;
        this.from.setStation('');
        this.to.setStation('');
        this.via1.setStation('');
        this.via2.setStation('');
        this.via3.setStation('');
        if (this.mode === 'fare') {
          this.from.setConfigure("corporationBind", "ＪＲ");
        } else if (this.mode === 'teiki') {
          this.from.setConfigure("corporationBind", "ＪＲ東日本");
        }
      }
    },
    search: function (type) {
      this.from.closeStationList();
      this.to.closeStationList();
      this.via1.closeStationList();
      this.via2.closeStationList();
      this.via3.closeStationList();
      this.errors.splice(0);
      if (this.from.getStationName().length === 0) {
        if (this.from.getStation().length === 0) {
          this.errors.push('乗車駅を入力してください');
        } else {
          this.errors.push('乗車駅に誤りがあります');
        }
      }
      if (this.viaCount === 1 && this.via1.getStationName().length === 0) {
        if (this.via1.getStation().length === 0) {
          this.errors.push('経由駅を入力してください');
        } else {
          this.errors.push('経由駅に誤りがあります');
        }
      } else if (this.viaCount === 2 && this.via2.getStationName().length === 0) {
        if (this.via2.getStation().length === 0) {
          this.errors.push('経由駅を入力してください');
        } else {
          this.errors.push('経由駅に誤りがあります');
        }
      } else if (this.viaCount === 3 && this.via3.getStationName().length === 0) {
        if (this.via3.getStation().length === 0) {
          this.errors.push('経由駅を入力してください');
        } else {
          this.errors.push('経由駅に誤りがあります');
        }
      }
      if (this.to.getStationName().length === 0) {
        if (this.to.getStation().length === 0) {
          this.errors.push('降車駅を入力してください');
        } else {
          this.errors.push('降車駅に誤りがあります');
        }
      }
      if (this.from.getStationName().length > 0 && this.from.getStationName() === this.to.getStationName() && this.viaCount === 0) {
        this.errors.push('乗車駅と降車駅が同一です');
      }
      if (this.errors.length === 0) {
        let viaList = [];
        viaList.push(this.from.getStationName());
        if (this.via1.getStationCode()) {
          viaList.push(this.via1.getStationName());
        }
        if (this.via2.getStationCode()) {
          viaList.push(this.via2.getStationName());
        }
        if (this.via3.getStationCode()) {
          viaList.push(this.via3.getStationName());
        }
        viaList.push(this.to.getStationName());
        this.$store.commit('setViaList', viaList);
        this.$store.commit('setType', type);
        this.$store.commit('setMode', this.mode);
        this.$store.commit('setTeikiKind', this.teikiKind);
        this.$router.push({ name: 'SearchCourse' });
      }
    },
    addVia: function () {
      this.errors.splice(0);
      this.viaCount++;
    },
    deleteVia: function (index) {
      this.errors.splice(0);
      const via2 = this.via2.getStationName();
      const via3 = this.via3.getStationName();
      switch (index) {
        case 1:
          if (this.viaCount === 3) {
            this.via1.setStation(via2);
            this.via2.setStation(via3);
            this.via3.setStation('');
            this.via3.closeStationList();
          } else if (this.viaCount === 2) {
            this.via1.setStation(via2);
            this.via2.setStation('');
            this.via2.closeStationList();
          } else {
            this.via1.setStation('');
            this.via1.closeStationList();
          }
          break;
        case 2:
          if (this.viaCount === 3) {
            this.via2.setStation(via3);
            this.via3.setStation('');
            this.via3.closeStationList();
          } else {
            this.via2.setStation('');
            this.via2.closeStationList();
          }
          break;
        case 3:
          this.via3.setStation('');
          this.via3.closeStationList();
          break;
      }
      this.viaCount--;
    },
    openUpdate: function () {
      window.open('./#/update', '_blank');
    },
  }
}
</script>

<style scoped>
.section {
  width: 60rem;
}

ul {
  list-style-type: none;
}

li {
  padding-left: em;
  text-indent: -1em;
}
</style>
